import Player from '@/models/Player';

export default {
  name: 'PlayerTitle',
  props: {
    player: {
      type: Player,
      default: null,
    },
    clubId: {
      type: String,
      default: null,
    },
    title: {
      type: [String, Object],
      default: null,
    },
  },
  computed: {
    currentClubId() {
      return this.clubId || null;
    },
    titleMeta() {
      if (this.player) {
        return this.player.getTitleMeta(this.currentClubId) || null;
      }

      if (!this.title) {
        return null;
      }

      if (typeof this.title === 'string') {
        const code = this.title.trim();
        if (!code) return null;
        return {
          code,
          name: code,
          scope: 'local',
          className: 'utitle--local',
        };
      }

      const code = String(this.title?.code || '').trim();
      if (!code) return null;

      const scope = this.title?.scope === 'fide' ? 'fide' : 'local';
      return {
        code,
        name: String(this.title?.name || code).trim(),
        scope,
        className: scope === 'fide' ? 'utitle--fide' : 'utitle--local',
      };
    },
  },
};
